import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'bl-ranking-medicos-action',
    template: `
    <span>
      {{ displayValue }}
      @if (!params.node.rowPinned && !params.node.footer) {
        <button
          pButton
          type="button"
          icon="pi pi-list"
          class="p-button-sm p-button-text p-0"
          style="vertical-align: baseline"
          pTooltip="Listar Guias"
          (click)="onButtonClick()"
        ></button>
      }
    </span>
    `,
    standalone: false
})
export class RankingMedicosConsultasCellRenderer implements ICellRendererAngularComp {
  params: ICellRendererParams;
  value: string;
  displayValue: string;

  constructor() {}

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.updateValue(params);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams) {
    this.params = params;

    this.value = params.value;
    this.displayValue = params.valueFormatted ?? params.value;
  }

  onButtonClick() {
    this.params.context.parentComponent.showDialogFor(this.params.data.cd_guia_monitor);
  }
}
